import styled from 'styled-components'

const TasksStyled = styled.div``

export default TasksStyled



// WEBPACK FOOTER //
// ./src/Tasks/TasksStyled/index.js